import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';

const ConfirmDeleteModal = ({ open, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onClose} sx={{ '& .MuiDialog-paper': { borderRadius: '10px', padding: 2 } }}>
            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', color: '#D32F2F' }}>
                Confirm Delete
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', padding: 2 }}>
                <Typography variant="body1" sx={{ color: '#757575' }}>
                    Are you sure you want to delete this client?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', padding: 2 }}>
                <Button onClick={onClose} variant="outlined" sx={{ color: '#1976D2', borderColor: '#1976D2' }}>
                    No
                </Button>
                <Button onClick={onConfirm} variant="contained" color="error" sx={{ marginLeft: 2 }}>
                    Yes, Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
